import { Component, OnInit } from '@angular/core';
import { NextConfig } from '../../../app-config';
import { Location } from '@angular/common';
import { OnlineOfflineService } from '../../../services/online-offline.service';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { OfflineQueueService } from '../../../services/offline-queue.service';
@Component({
  standalone: false,
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public nextConfig: any;
  public navCollapsed: boolean;
  public navCollapsedMob: boolean;
  public windowWidth: number;
  modalOptions!: NgbModalOptions;


  closeResult!: string;
  // validation
  public errorMessageList = [];

  public countOfflineTransaction: number = 0;
  public isResyncing: boolean = false;
  public hideChat: boolean = true;

  constructor(private location: Location,
    public readonly onlineOfflineService: OnlineOfflineService,
    private offlineQueueService: OfflineQueueService,
    private modalService: NgbModal
  ) {
    this.nextConfig = NextConfig.config;

    let currentURL = this.location.path();
    //const baseHerf = this.location['_baseHref'];
    const baseHerf = ""; //does not work in angular 16, assume baseHerf is unused
    if (baseHerf) {
      currentURL = baseHerf + this.location.path();
    }

    this.windowWidth = window.innerWidth;

    if (currentURL === baseHerf + '/layout/collapse-menu'
      || currentURL === baseHerf + '/layout/box'
      || (this.windowWidth >= 992 && this.windowWidth <= 1024)) {
      this.nextConfig.collapseMenu = true;
    }

    //IFS-Style Note: this will collapse menu when window width between 992px and 1024px
    this.navCollapsed = (this.windowWidth >= 992) ? this.nextConfig.collapseMenu : false;
    //this.navCollapsed = false;

    this.navCollapsedMob = false;

    window.addEventListener('ErrorEvent', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      const offlineMessage: any = document.getElementById('offline');
      offlineMessage.style.display = 'block';
    });
  }

  ngOnInit() {

    // Resync
    if (this.onlineOfflineService.isOnline && this.onlineOfflineService.isAuthenticated) {
      this.offlineQueueService.resyncData();
    }

    // Subscribe to countOfflineTransaction
    this.offlineQueueService.countOfflineTransaction.subscribe((value) => {
      console.log('subscribe countOfflineTransaction', value);
      this.countOfflineTransaction = value;
    });

    // Subscribe to isResyncing
    this.offlineQueueService.isResyncing.subscribe((value) => {
      console.log('subscribe isResyncing', value);
      this.isResyncing = value;
    });

    if (this.windowWidth < 992) {
      this.nextConfig.layout = 'vertical';
      setTimeout(() => {
        document.querySelector('.pcoded-navbar')!.classList.add('menupos-static');
        (document.querySelector('#nav-ps-next') as HTMLElement).style.maxHeight = '100%'; // 100% amit
      }, 500);
    }
  }

  subscriptions: Subscription[] = [];
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe())
  }

  navMobClick() {
    if (this.windowWidth < 992) {
      if (this.navCollapsedMob && !(document.querySelector('app-navigation.pcoded-navbar')!.classList.contains('mob-open'))) {
        this.navCollapsedMob = !this.navCollapsedMob;
        setTimeout(() => {
          this.navCollapsedMob = !this.navCollapsedMob;
        }, 100);
      } else {
        this.navCollapsedMob = !this.navCollapsedMob;
      }
    }
  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', keyboard: true, backdrop: false }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public navToggleChat() {
    this.hideChat = !this.hideChat
    if (!this.hideChat) {
      setTimeout(() => {
        document.getElementById("chatInputField")!.focus();;
      });
    }

    // forces pages with apex charts to resize
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
}
